
const ProductJson = document.getElementById('ProductJson'); // 상품 정보
const ProductOptions = document.getElementById('ProductOptions'); // 상품 옵션 정보
const productOptionsData = JSON.parse(ProductOptions.textContent);
const rowVariants = JSON.parse(ProductJson.textContent);
const variantPicker = document.querySelector('variant-picker');
const currentUrl = window.location.pathname;

function updateOptionHtml(selected_variant_id) {
    const safePath = encodeURI(decodeURI(window.location.pathname));
    const fetchUrl = `${safePath}?variant=${selected_variant_id}`;
    
    fetch(fetchUrl)
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.text();
        })
        .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newVariantPicker = html.querySelector('variant-picker');
            
            // 요소가 존재하는지 확인 후 실행 (방어 코드)
            if (newVariantPicker && variantPicker) {
                variantPicker.innerHTML = newVariantPicker.innerHTML;
                
                // URL 업데이트
                history.replaceState({}, '', fetchUrl);
                
                // 가격 업데이트
                const newProductPrice = html.querySelector('#productPrice');
                if (newProductPrice) {
                    const productPrice = newProductPrice.textContent;
                    const currentPriceElem = document.getElementById('productPrice');
                    if(currentPriceElem) {
                        currentPriceElem.textContent = productPrice;
                    }
                }
            } else {
                console.warn('Variant picker element not found in the response.');
            }
        })
        .catch(error => {
            console.error('Error updating option item:', error);
        });  
}

function updateOptionItem(position, selected_variant_id){
    const now_variant = rowVariants.find(variant => variant.id === selected_variant_id);
    let select_variant = now_variant;
    let option1_index = 0;
    let option2_index = 0;
    let option3_index = 0;
    let option1_value = productOptionsData[0]?.['values']?.[option1_index] || null;
    let option2_value = productOptionsData[1]?.['values']?.[option2_index] || null;
    let option3_value = productOptionsData[2]?.['values']?.[option3_index] || null;
    const select_options = [option1_value, option2_value, option3_value];

    switch (position) {
        case 1:
            select_options[0] = now_variant.option1;
            break;
        case 2:
            select_options[0] = now_variant.option1;
            select_options[1] = now_variant.option2;
            break;
        default:
            break;
    }

    select_variant = rowVariants.find((variant)=>{
        if(position == 1 && variant.option1 == select_options[0] && variant.available){
            return variant;
        }else if(position == 2 && variant.option1 == select_options[0] && variant.option2 == select_options[1] && variant.available){
            return variant;
        }else{
            return null;
        }
    })

    updateOptionHtml(select_variant.id);
} 

function changeQuantityProduct(type){
    const quantityInput = document.getElementById('quantity');
    const btnQuantityMinus = document.getElementById('btnMinus');
    const btnQuantityPlus = document.getElementById('btnPlus');
    const value = parseInt(quantityInput.value);
    const min = parseInt(quantityInput.min);
    const max = parseInt(quantityInput.max);

    if(type === 'minus'){
        quantityInput.value = value - 1;
        btnQuantityPlus.disabled = false
        
        if(value - 1 <= min){
            btnQuantityMinus.disabled = true;
        }else{
            btnQuantityMinus.disabled = false;
        }

    }else if(type === 'plus'){
        quantityInput.value = value + 1;
        btnQuantityMinus.disabled = false

        if(value + 1 >= max){
            btnQuantityPlus.disabled = true;
        }else{
            btnQuantityPlus.disabled = false;
        }
    }
}